import { Text, VStack } from '@chakra-ui/react'
import { useInView } from 'react-intersection-observer'
import { useTrail } from 'react-spring'
import { useTranslation } from 'next-i18next'

import ContentLayout from '@/features/aboutUs/components/ContentLayout'
import { AnimatedText, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

function OurBelief(): React.ReactElement {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const springs = useTrail(3, {
    to: {
      transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
      opacity: inView ? 1 : 0,
    },
    config: DEFAULT_SPRING_CONFIG,
  })

  const { t } = useTranslation('aboutUs')

  return (
    <ContentLayout
      imagePlacement="left"
      bgImage={{
        base: '/images/about-us/our-belief-mobile.png',
        lg: '/images/about-us/our-belief.png',
      }}
      imageAlt="Our belief"
    >
      <Text
        as="h1"
        textStyle="landingSectionTitle"
        sx={{
          textAlign: {
            base: 'center',
            lg: 'left',
          },
          mb: { base: 10, md: 14 },
          mt: 0,
        }}
      >
        {t('ourBelief.title')}
      </Text>
      <VStack
        ref={ref}
        spacing={{ base: 4, md: 8 }}
        sx={{
          alignItems: 'stretch',
          fontSize: {
            base: 'xl',
            md: '2xl',
          },
        }}
      >
        <AnimatedText style={springs[0]}>
          {t('ourBelief.paragraph.0')}
        </AnimatedText>
        <AnimatedText sx={{ fontWeight: 'medium' }} style={springs[1]}>
          {t('ourBelief.paragraph.1')}
        </AnimatedText>
        <AnimatedText style={springs[2]}>
          {t('ourBelief.paragraph.2')}
        </AnimatedText>
      </VStack>
    </ContentLayout>
  )
}

export default OurBelief
